// input: route info + fetch mapping config
// output: array of fetch action creators
export default function applyRouteFetchMapping(config, pathname) {
  var actionDataFns = [];

  config.some(regexAndActionDataFn => {
    const regex = regexAndActionDataFn[0];
    const actionDataFn = regexAndActionDataFn[1];
    const matchData = pathname.match(regex);
    if (matchData) {
      actionDataFns.push(actionDataFn(...matchData.slice(1)));
      return true; // break
    }
    return false;
  });

  return actionDataFns;
}
